import { Minus, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { useCartActions } from "../hooks/useCartActions";
import { getProductPdpUrl } from "../../../../utils/url.utils";
import { formatDiscount, formatPrice } from "../../../../utils/price.utils";
// import { useNavigate } from "react-router-dom";

const CartItem = ({ item }) => {
    const {
        updatingId,
        handleRemoveItem,
        handleUpdateQty,
        handleMoveToWishlist,
        pinset,
    } = useCartActions();
    // const navigate = useNavigate();

    return (
        <div className="cart-item" style={{ background:"#FFF"}}>
            <div className="item-image">
                <Link to={getProductPdpUrl(item.product?.action_url, item.product?.sku)} target="_blank" >
                    <img
                        className="img-cart-page pointer-crusser"
                        src={item.product?.media}
                        alt={item.product?.name}
                        loading="lazy"
                    />
                </Link>
            </div>

            <div className="item-details">
                <div className="itemssection"> 
                  <h4 className="item-title pointer-crusser">
                    <Link
                        to={getProductPdpUrl(item.product?.action_url, item.product?.sku)}
                        target="_blank"
                        >
                        <span className="product-name-span">
                            {item.product?.name}
                        </span>
                    </Link>
                  </h4>
                  <span className="price_details_cart">
                    {formatPrice(item.product?.selling_price)}
                    {item.product.discount > 0 && (
                        <span className="sub-1" style={{bottom:"0"}}>
                            <del>{formatPrice(item.product?.mrp)}</del>
                            &nbsp;
                            <span className="dis-sub">
                                {formatDiscount(item.product?.discount)}
                            </span>
                        </span>
                    )}
                  </span>
                </div>

                <p> <span style={{fontWeight:"600"}}> Color : </span> <span>{item.product?.color}</span></p>
                <p> <span style={{fontWeight:"600"}}> TAT Delivery :</span> <span>{pinset?.delivery_tat}</span></p>

                <div className="root_qtn_cart" style={{ marginTop:"0", paddingTop:"0"}}>
                    <div className="subroot_sector_qtn">
                        <p> Qty: </p>
                        <div className="quantity">
                            <button
                                className="tracker-btn"
                                onClick={() =>
                                    handleUpdateQty(item.product_id, item.cart_qty - 1)
                                }
                                disabled={updatingId === item.product_id}
                              >
                                <Minus size={13} strokeWidth={1.25} />
                            </button>

                            <span className="qtn_track">{item.cart_qty}</span>

                            <button className="tracker-btn"
                                onClick={() =>
                                    handleUpdateQty(item.product_id, item.cart_qty + 1)
                                }
                                disabled={updatingId === item.product_id}
                             >
                                <Plus size={13} strokeWidth={1.25} />
                            </button>
                        </div>
                    </div>

                    <div className="actions" style={{ textDecoration:"none", gap:"0"}}>
                        <span onClick={() => handleRemoveItem(item.id)} className="cart-items-box cart-border-right"> <span> <i class="bi bi-trash"></i> </span> Remove   </span>
                        <span onClick={() => handleMoveToWishlist(item)} className="cart-items-box">
                            <span> <i class="bi bi-heart"></i> </span> Move to Wishlist  
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CartItem;